<template>
  <div>
    <training-toolbar v-if="userInfo"/>
    <div class="card mx-md-5 mt-3 mb-3 bg-form">
      <card-header v-if="userInfo"
        :title="$t('parametrics.sessionsTitle')"
        :iconName="'file-earmark-check'"
      />
      <b-card-body>
        <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
        <b-alert v-for="error in errors" :key="error.message" v-model="popAlert"  variant="danger" dismissible>
          {{ error.message }}
        </b-alert>

        <b-row v-if="allModules">
          <b-form-group
            id="input-module"
            :label="$t('parametrics.module')"
            label-for="module"
            label-align="left"
            class="col-12"
          >
            <v-select
              id="module"
              :options="allModules"
              placeholder=""
              :clearable='false'
              label="title"
              v-model="selectedModule"
              class="bg-white rounded"
              @input="getSessions(selectedModule)"
            >
              <template #no-options="{ }">
                {{ $t("parametrics.noRequiredModulesToAdd") }}
              </template>
            </v-select>
          </b-form-group>
        </b-row>
        <hr />

        <template v-if="sessions">
          <sessions-table :sessions="sessions" :module="selectedModule" 
            v-on:error:api.capture="handleError" @refresh-list="getSessions"/>
        </template>
      </b-card-body>
    </div>
  </div>
</template>

<script>
import CardHeader from '../../components/common/cardHeader.vue'
import trainingService from '../../services/training.service';
import { handleApiError } from '../../services/error.service';
import TrainingToolbar from '../../components/common/trainingToolbar.vue';
import SessionsTable from '../../components/parametrics/sessionsTable.vue';
import {hasRole} from "esep/src/services/utils";
import {roles, routes} from "esep/src/services/routing.service";


export default {
  components: {
    CardHeader,
    TrainingToolbar,
    SessionsTable
  },
  mounted() {
    trainingService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        if (!hasRole(this.userInfo,roles.training.parametrics)){
          location.replace(routes.nothing);
        }
        this.$store.state.userInfo = this.userInfo;
        this.fetchRoles();
      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
    this.getAllModules();
    this.getSessions(null);
  },
  data() {
    return {
      userInfo: null,
      popSuccessAlert: false,
      popAlert: false,
      successMessage: null,
      errors: null,
      isAdmin: false,
      isTrainingAdmin: false,
      isTrainingMod: false,
      isReady: false,
      sessions: null,
      allModules: null,
      selectedModule: null
    }
  }, 
  methods: {
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
    },
    fetchRoles() {
      for(var i=0; i< this.userInfo.roles.length; i++){
        if(this.userInfo.roles[i].name == "ADMIN" ) {
          this.isAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAINING_ADMIN") {
          this.isTrainingAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAINING_MOD"){
          this.isTrainingMod = true;
        }
      }
    },
    getAllModules() {
      trainingService.getModulesByCriteria(true, null, false).then(
        (response) => {
          this.$log.debug("modules")
          this.$log.debug(response.data);
          this.allModules = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getSessions(module) {
      this.sessions = null;
      if(module) {
        let archived= false;
        trainingService.getSessionsByCriteria(module.id, archived).then(
          (response) => {
            this.$log.debug("sessions");
            this.$log.debug(response.data);
            this.sessions = response.data.filter(session => session.type == 'LESSON');
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.handleError(errorMessage);
          }
        )
      } else {
        this.sessions = [];
      }
      
    }
  }
}
</script>